export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  homeStats: (startDateIso: string, endDateIso: string, businessId: string) =>
    [...dashboardQueryKeys.all, 'home-stats', businessId, startDateIso, endDateIso] as const,
};
